export default __webpack_public_path__ + "static/media/new_bg.59902a4f.svg";